import {
  targetGroupsByVersionConstants,
  createTargetGroupsByVersionConstants,
  editTargetGroupsByVersionConstants,
  addTargetGroupsByVersionConstants,
  removeTargetGroupsByVersionConstants,
  deleteTargetGroupsByVersionConstants,
} from "../_redux-constants";

export function targetGroupsVersionReducer(
  state = {
    targetGroupsByVersionLoading: false,
    targetGroupsByVersionData: null,
    targetGroupsByVersionError: null,

    createTargetGroupsByVersionLoading: false,
    createTargetGroupsByVersionData: null,
    createTargetGroupsByVersionError: null,

    editTargetGroupsByVersionLoading: false,
    editTargetGroupsByVersionData: null,
    editTargetGroupsByVersionError: null,

    addTargetGroupsByVersionLoading: false,
    addTargetGroupsByVersionData: null,
    addTargetGroupsByVersionError: null,

    removeTargetGroupsByVersionLoading: false,
    removeTargetGroupsByVersionData: null,
    removeTargetGroupsByVersionError: null,

    deleteTargetGroupsByVersionLoading: false,
    deleteTargetGroupsByVersionData: null,
    deleteTargetGroupsByVersionError: null,
  },
  action
) {
  switch (action.type) {
    case targetGroupsByVersionConstants.TARGET_GROUPS_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        targetGroupsByVersionLoading: true,
        targetGroupsByVersionData: null,
        targetGroupsByVersionError: null,
      });
    case targetGroupsByVersionConstants.TARGET_GROUPS_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsByVersionLoading: false,
        targetGroupsByVersionData: action.data,
      });
    case targetGroupsByVersionConstants.TARGET_GROUPS_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        targetGroupsByVersionLoading: false,
        targetGroupsByVersionData: null,
        targetGroupsByVersionError: action.error,
      });
    case createTargetGroupsByVersionConstants.CREATE_TARGET_GROUPS_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        createTargetGroupsByVersionLoading: true,
        createTargetGroupsByVersionData: null,
        createTargetGroupsByVersionError: null,
      });
    case createTargetGroupsByVersionConstants.CREATE_TARGET_GROUPS_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        createTargetGroupsByVersionLoading: false,
        createTargetGroupsByVersionData: action.data,
      });
    case createTargetGroupsByVersionConstants.CREATE_TARGET_GROUPS_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        createTargetGroupsByVersionLoading: false,
        createTargetGroupsByVersionData: null,
        createTargetGroupsByVersionError: action.error,
      });
    case editTargetGroupsByVersionConstants.EDIT_TARGET_GROUPS_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        editTargetGroupsByVersionLoading: true,
        editTargetGroupsByVersionData: null,
        editTargetGroupsByVersionError: null,
      });
    case editTargetGroupsByVersionConstants.EDIT_TARGET_GROUPS_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        editTargetGroupsByVersionLoading: false,
        editTargetGroupsByVersionData: action.data,
      });
    case editTargetGroupsByVersionConstants.EDIT_TARGET_GROUPS_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        editTargetGroupsByVersionLoading: false,
        editTargetGroupsByVersionData: null,
        editTargetGroupsByVersionError: action.error,
      });
    case addTargetGroupsByVersionConstants.ADD_TARGET_GROUPS_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        addTargetGroupsByVersionLoading: true,
        addTargetGroupsByVersionData: null,
        addTargetGroupsByVersionError: null,
      });
    case addTargetGroupsByVersionConstants.ADD_TARGET_GROUPS_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        addTargetGroupsByVersionLoading: false,
        addTargetGroupsByVersionData: action.data,
      });
    case addTargetGroupsByVersionConstants.ADD_TARGET_GROUPS_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        addTargetGroupsByVersionLoading: false,
        addTargetGroupsByVersionData: null,
        addTargetGroupsByVersionError: action.error,
      });
    case removeTargetGroupsByVersionConstants.REMOVE_TARGET_GROUPS_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        removeTargetGroupsByVersionLoading: true,
        removeTargetGroupsByVersionData: null,
        removeTargetGroupsByVersionError: null,
      });
    case removeTargetGroupsByVersionConstants.REMOVE_TARGET_GROUPS_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        removeTargetGroupsByVersionLoading: false,
        removeTargetGroupsByVersionData: action.data,
      });
    case removeTargetGroupsByVersionConstants.REMOVE_TARGET_GROUPS_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        removeTargetGroupsByVersionLoading: false,
        removeTargetGroupsByVersionData: null,
        removeTargetGroupsByVersionError: action.error,
      });

    case deleteTargetGroupsByVersionConstants.DELETE_TARGET_GROUPS_BY_VERSION_LOADING:
      return Object.assign({}, state, {
        deleteTargetGroupsByVersionLoading: true,
        deleteTargetGroupsByVersionData: null,
        deleteTargetGroupsByVersionError: null,
      });
    case deleteTargetGroupsByVersionConstants.DELETE_TARGET_GROUPS_BY_VERSION_SUCCESS:
      return Object.assign({}, state, {
        deleteTargetGroupsByVersionLoading: false,
        deleteTargetGroupsByVersionData: action.data,
      });
    case deleteTargetGroupsByVersionConstants.DELETE_TARGET_GROUPS_BY_VERSION_FAILURE:
      return Object.assign({}, state, {
        deleteTargetGroupsByVersionLoading: false,
        deleteTargetGroupsByVersionData: null,
        deleteTargetGroupsByVersionError: action.error,
      });
    default:
      return state;
  }
}
